import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom';

function TabElement({id, name, link, activeTab, setActiveTab, onClick, count}) {

  return (
    <Link to={link} onClick={onClick} id={id} className={'p-4 lg:p-5 px-2 flex w-full lg:w-44 items-center text-center justify-center cursor-pointer ' + (activeTab === id ? ' border-t-sky-500 border-t-2 bg-white text-sky-500' : "")}>
     {name}
      {(count !== undefined && count !== 0) &&
         <span class={"left-[12px] bottom-[12px] justify-center items-center text-sm flex top-0 relative rounded-full bg-sky-600 text-white" + (count < 99 ? ' h-[20px] w-[20px]' : ' h-[24px] w-[24px]')}>
        {count}
       </span>
      }
    </Link>
  )
}

export default TabElement